export enum SolicitorCaseStatusEnum {
  pending_ipa = "Pending IPA",
  ipa_received = "IPA Received",
  pending_lodgement = "Pending lodgement",
  completed = "Completed",
  cancelled = "Cancelled",
  rejected = "Rejected",
  invalid = "",
}
